
import React, { Component } from 'react'; 
import MediaRecorder from 'audio-recorder-polyfill'
import ShowModalPopUp from '../ShowModalPopUp';
export default class Record extends Component {
  constructor(props){
    super(props)
      this.state={
        startrec:false
      }
    
  }
  handleAction = async () => {
    const recorder = await this.recordAudio();
    this.setState({startrec:true, recorder:recorder})
    recorder.start();
  }
  handleActionstop = async () => {
    const recorder = this.state.recorder
    recorder.stop();
  }

  recordAudio = () =>
    new Promise(async resolve => {
      if(typeof navigator.mediaDevices !== 'undefined'){
      this.setState({startrec:true})
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      const audioChunks = [];
      mediaRecorder.addEventListener("dataavailable", event => {
        audioChunks.push(event.data);
      });
      
      const start = () => mediaRecorder.start();
      const stop = () =>
        new Promise(resolve => {
          mediaRecorder.addEventListener("stop", () => {
            const audioBlob = new Blob(audioChunks, {type:'audio/wav'});           
            this.props.onCallBackRecord(audioBlob)
            resolve({ audioBlob });
          });
          mediaRecorder.stop();
          this.setState({startrec:false, record:true})
        });
      resolve({ start, stop });
      } else {
        alert('Voice Recording/ Web Audio API not supported in this browser')
      }
    });
recordSaved = () =>{
  this.setState({record:false})
}
render(){
  return(
    <div className='recording'>
      {this.state.startrec ?<p><i class="fas fa-microphone RedColoring" onClick={()=>this.handleActionstop()}></i>
        <span style={{fontSize:'small'}}>&nbsp;Started Recording</span>
      </p>
      :<p> <i class="fas fa-microphone" onClick={()=>this.handleAction()}></i></p> }
      {this.state.record === true ? 
          <ShowModalPopUp message={'RecordingSaved'} 
          falseShowModalPopUp={this.recordSaved}/>
      : null}
  </div>
  )
}
}

